<template>
  <div id="content">
    <div class="container">
      <div id="page-header-fixed">
        <div class="container">
          <div id="page-header">
            <ul class="breadcrumb">
              <li class="icon">
                <a @click="$router.go(-1)">
                  <img src="/themes/ito/images/back-to.svg" alt="">
                </a>
              </li>
              <li class="active text-capitalize">{{ $t('assignments') }}</li>
            </ul>
            <div class="tools">
              <nav class="ito-tabs">
                <template v-for="tab in data_tabs">
                  <a class="cursor-pointer text-capitalize" :class="{ active: filter.status == tab }"
                     @click="asmFilter(tab)">{{ $t(tab) }}</a>
                </template>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div class="card card-assignment fade-down">
        <div class="card-body">
          <div class="card-title justify-content-between gap-3">
            <p class="title flex-fill" v-if="filter.status == 'incomplete'">{{ items.length }}
              {{ items.length > 1 ? $t('assignments') : $t('assignment') }} {{ $t('need_to_submit') }}</p>
            <p class="title flex-fill" v-else-if="filter.status == 'submitted'">{{ items.length }}
              {{ items.length > 1 ? $t('assignments') : $t('assignment') }} {{ $t('have_been_submitted') }}</p>
            <p class="title flex-fill" v-else-if="filter.status == 'completed'">{{ items.length }}
              {{ items.length > 1 ? $t('assignments') : $t('assignment') }} {{ $t('have_been_graded') }}</p>
            <p class="title flex-fill" v-else>{{ items.length }}
              {{ items.length > 1 ? $t('assignments') : $t('assignment') }}</p>
            <date-range-picker ref="picker" class="filter_date_picker" single-date-picker="range"
                               :locale-data="datepicker_locale" :auto-apply="true" :ranges="false" @update="asmFilter()"
                               opens="left" v-model="filter.date_range">
              <template v-slot:input="picker">
                <template v-if="picker.startDate || picker.endDate">
                  {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{
                    moment(picker.endDate).format('DD/MM/YYYY')
                  }}
                  <span class="clear"
                        @click="filter.date_range = { startDate: null, endDate: null }, asmFilter()"></span>
                </template>
                <template v-else>{{ $t('search_by_date') }}</template>
              </template>
            </date-range-picker>
          </div>
          <div class="card-content d-flex flex-column gap-3 mt-3">
            <div class="d-flex flex-column align-items-center justify-content-center text-center" v-if="errors.items">
              <h5>{{ $t(errors.items) }} </h5>
              <img class="mt-3" src="/themes/ito/images/mascot/isaac-extension.svg" alt="" width="125px">
            </div>
            <template v-else>
              <div class="assignment-item" v-for="(item, index) in items" :key="index">
                <div class="d-flex flex-column justify-content-start flex-fill gap-1">
                  <div class="d-flex gap-3">
                    <div class="d-flex flex-column">
                      <p class="text-primary"
                         v-if="item.submissions.status != 'over_due' && item.submissions.extend_time">{{
                          $t('extend')
                        }}</p>
                      <p class="text-primary"
                         v-if="item.submissions.status != 'over_due' && ((item.submissions.resubmit.attachments != null && item.submissions.resubmit.attachments.length > 0) || item.submissions.resubmit.desc != '')">
                        {{ $t('resubmit') }}
                        <span class="text-decoration-underline cursor-pointer" v-if="item.submissions.resubmit.desc != 'reason_resubmit_content'"
                              @click="showReasonResubmit(item)">{{ `(${$t('reason')})` }}</span>
                      </p>
                    </div>
                    <ul class="assignment-item-posistion d-flex align-items-center">
                      <li v-if="item.grade">{{ item.grade }}</li>
                      <li v-if="item.subject">{{ item.subject }}</li>
                      <li v-if="item.unit">{{ item.unit }}</li>
                      <li v-if="item.lesson">{{ item.lesson }}</li>
                    </ul>
                  </div>
                  <div class="d-flex gap-3 align-items-center">
                    <h5 class="assignment-name">{{ item.name }}
                      <span class="badge" :class="'bg-' + item.submissions.status">{{
                          $t(item.submissions.status)
                        }}</span>
                      <span class="badge bg-new" v-if="item.is_new">{{ $t('new') }}</span>
                    </h5>
                    <p class="assignment-resubmit-attempts" v-if="item.total_submission > 0">{{ `${$t('attempts')}:` }}
                      <strong><span>{{ item.submissions.total_submission }}</span>/{{ item.total_submission }}</strong>
                    </p>
                  </div>
                  <ul class="d-flex">
                    <li>
                      {{ $t('start_date') }}: <span>{{ moment.unix(item.start_time).format('DD/MM/YYYY HH:mm') }}</span>
                    </li>
                    <li>
                      {{ $t('end_date') }}: <span>{{ moment.unix(item.end_time).format('DD/MM/YYYY HH:mm') }}</span>
                    </li>
                    <li>
                      {{ $t('teacher') }}: <span>{{ item.teacher }}</span>
                    </li>
                  </ul>
                </div>

                <div class="d-flex flex-column gap-1 justify-content-center align-items-end"
                     v-if="!['not_started'].includes(item.submissions.status)">
                  <button class="ito-btn ito-btn-primary" @click="OpenAssignment(item)">
                    <template v-if="['submitted', 'completed', 'over_due'].includes(item.submissions.status)">
                      {{ $t('view_assignment') }}
                    </template>
                    <!-- to_do  draft-->
                    <template v-else>
                      {{ $t('do_assignment') }}
                    </template>
                  </button>
                  <div class="assignment-point text-capitalize gap-1" v-if="item.submissions.status == 'completed'">
                    {{ $t('asm_point') }}
                    <span>{{ submissionPointFormat(item.submissions.point) }}</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="reSubmitModal" tabindex="-1" aria-labelledby="reSubmitModalLabel" aria-hidden="false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content box-shadow-main">
          <button type="button" class="close-popup" data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="modal-body d-flex justify-content-center my-5" v-if="!resubmission">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div class="modal-body" v-else>
            <h3 class="popup-title mb-20">{{ $t('resubmit_reason') }}</h3>
            <div class="row g-3">
              <div class="col-12" v-if="resubmission.desc !== '' && resubmission.desc !== 'reason_resubmit_content'">
                <label class="m-0 text-bold">{{ $t('reason') }}</label>
                <div class="border rounded p-3 reason-desc">
                  <p>{{ resubmission.desc }}</p>
                </div>
              </div>
              <div class="col-12" v-if="resubmission.attachments.length">
                <label class="m-0 text-bold">{{ $t('attached_file') }}</label>
                <div class="w-100 d-flex flex-column gap-3 p-0 position-relative">
                  <div class="w-100 d-flex gap-3 align-items-center bg-white border-dashed rounded-1rem px-4 py-3"
                       v-for="(attachment, index) in resubmission.attachments" :key="index">
                    <i class="ito-icon" :class="`ito-icon-material-${attachment.extension}`"></i>
                    <div class="d-flex flex-fill flex-column justify-content-center overflow-hidden">
                      <p class="material-name text-truncate" :title="attachment.name">{{ attachment.name }}</p>
                      <p class="material-value">{{ formatBytes(attachment.size) }}</p>
                    </div>
                    <button class="ito-btn ito-btn-primary" @click="viewFile(attachment.id, attachment.url)">
                      {{ $t('view') }} <i class="ito-icon ito-icon-eyes"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="assignmentDetail" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
         aria-labelledby="assignmentDetailLabel" aria-hidden="false">
      <div class="modal-dialog modal-dialog-centered modal-95">
        <div class="modal-content overflow-hidden">
          <AssignmentsDetail :assignment_id="item.id" :key="item.id" v-if="item && isModalShow" @reload="fetch()"
                             @close="isModalShow = false"></AssignmentsDetail>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import AssignmentsDetail from './AssignmentDetail';
import {getListAssignment} from "../../models/assignment";
import {ErrorModal, ConfirmDialogue} from '../modal';
import ModalDialog from '../modal/ModalDialog.vue'

import DateRangePicker from 'vue2-daterange-picker'
import '/public/themes/ito/css/vue2-daterange-picker.css'

export default {
  name: "Assignments",
  components: {
    DateRangePicker,
    ErrorModal,
    ConfirmDialogue,
    AssignmentsDetail,
    ModalDialog,
  },
  title: 'Assignments',
  data() {

    return {
      assignments: [],
      items: [],
      item: undefined,
      inputed_answer: '',
      answer: undefined,
      filelist: [],
      errors: {
        file: undefined,
        items: undefined,
        item: undefined,
      },
      error: '',
      filter: {
        date_range: {
          startDate: null,
          endDate: null
        },
        status: 'all'
      },
      datepicker_locale: {
        daysOfWeek: [this.$i18n.t('sun'), this.$i18n.t('mon'), this.$i18n.t('tue'), this.$i18n.t('wed'), this.$i18n.t('thu'), this.$i18n.t('fri'), this.$i18n.t('sat')],
        monthNames: [this.$i18n.t('month_1'), this.$i18n.t('month_2'), this.$i18n.t('month_3'), this.$i18n.t('month_4'), this.$i18n.t('month_5'), this.$i18n.t('month_6'), this.$i18n.t('month_7'), this.$i18n.t('month_8'), this.$i18n.t('month_9'), this.$i18n.t('month_10'), this.$i18n.t('month_11'), this.$i18n.t('month_12')],
      },
      data_tabs: ['incomplete', 'submitted', 'completed', 'all'],
      supported_formats: ['jpeg', 'png', 'gif', 'mp3', 'mp4', 'mov', 'doc', 'docx', 'xls', 'xlsx', 'pdf'],
      modal: {
        title: '',
        message: '',
      },
      resubmission: undefined,
      isModalShow: false

    };
  },

  mounted() {
    this.fetch()

  },
  updated() {
    this.$nextTick(() => {
      $('#reSubmitModal').on('hidden.bs.modal', function (e) {
        this.resubmission = undefined
      })
    })
  },

  methods: {
    submissionPointFormat(value) {
        if (!value || isNaN(value)) return 0;
        return parseFloat(value.toFixed(2));
    },
    fetch() {
      this.$store.commit("setLoading", true);
      getListAssignment().then((response) => {
        this.$store.commit("setLoading", false);
        if (response.data.code != 0) {
          this.errors.items = response.data.msg;
          return;
        }
        const assignments = response.data.results
        if (!assignments || assignments.length <= 0) {
          this.errors.items = 'empty_data';
          return;
        }
        this.assignments = assignments
        this.item = undefined
        this.asmFilter()
      });
      this.$forceUpdate();
    },

    asmFilter(tab = this.filter.status) {
      this.$store.commit("setLoading", true);
      this.filter.status = tab
      var results = this.assignments;
      switch (this.filter.status) {
        case 'incomplete':
          results = results
              .filter((el) => el.submissions.status == 'not_started' || el.submissions.status == 'draft' || el.submissions.status == 'to_do')
              .sort((a, b) => a.end_time - b.end_time);
          break;
        case 'submitted':
          results = results
              .filter((el) => el.submissions.status == this.filter.status)
              .sort((a, b) => b.end_time - a.end_time);
          break;
        case 'completed':
          results = results
              .filter((el) => el.submissions.status == this.filter.status)
              .sort((a, b) => b.end_time - a.end_time);

          break;
        default:
          var todo = results.filter( (el) => el.submissions.status == 'draft' )
              .sort((a, b) => a.end_time - b.end_time);
          var notStarted = results.filter((el) => el.submissions.status == 'not_started' || el.submissions.status == 'to_do')
              .sort((a, b) => a.end_time - b.end_time);

          var submitted = results.filter((el) => el.submissions.status == 'submitted')
              .sort((a, b) => a.end_time - b.end_time);

          var completed = results.filter((el) => el.submissions.status == 'completed')
              .sort((a, b) => a.end_time - b.end_time);
          var overdue = results.filter((el) => el.submissions.status == 'over_due')
              .sort((a, b) => a.end_time - b.end_time);

          results = todo.concat(notStarted).concat(submitted).concat(completed).concat(overdue)

          break;
      }
      if (this.filter.date_range.startDate && this.filter.date_range.endDate) {
        var start_date = this.moment(this.filter.date_range.startDate)
        var end_date = this.moment(this.filter.date_range.endDate)
        results = results.filter((el) => this.moment.unix(el.start_time).isSameOrAfter(start_date, 'day') && this.moment.unix(el.end_time).isSameOrBefore(end_date, 'day'));
      }
      if (results.length <= 0) {
        this.errors.items = 'empty_data';
      } else {
        this.errors.items = undefined
      }
      this.items = results
      this.$store.commit("setLoading", false);
    },

    OpenAssignment(item) {
      this.item = item;
      this.isModalShow = true
      $('#assignmentDetail').modal('show');
    },

    showReasonResubmit(item) {
      if (!item.submissions.resubmit.attachments && item.submissions.resubmit.desc === '') return;
      this.resubmission = item.submissions.resubmit
      $('#reSubmitModal').modal('show')
    },

    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },

    viewFile(attachment_id, file) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'];
      const fileExtension = file.split('.').pop().toLowerCase();
      if (imageExtensions.includes(fileExtension)) {
        this.$swal({
          imageUrl: file,
          imageHeight: 'auto',
          imageWidth: '100%',
          imageAlt: attachment_id,
          width: '80%',
          showCloseButton: true,
          closeButtonHtml: '<i class="ito-icon-close modal-close"></i>',
          showConfirmButton: false,
        });
      } else {
        this.$swal({
          html: ` <div style="height:90vh;display:flex;align-items:center;justify-content:center;"><embed src="${file}" type="application/pdf" width="100%" height="100%" /></div>`,
          width: '80%',
          showCloseButton: true,
          closeButtonHtml: '<i class="ito-icon-close modal-close"></i>',
          showConfirmButton: false,
        });
      }
    },
  }
}
</script>

<style scoped>
.reason-desc{
  white-space: pre-line;
}
.filter_date_picker {
  width: 250px;
}

.card-assignment {
  overflow: unset;
}

.card-assignment .card-body {
  background: #E7E7E740;
  border-radius: 16px;
}

.card > .card-body > .card-title {
  border-radius: 16px 16px 0 0;

}

.assignment-item {
  display: flex;
  gap: 1rem;
  background: #FFFFFF;
  padding: 10px 20px;
  border-radius: 10px;
  box-shadow: 4px 4px 0px 0px #00000012, 0px 4px 0px 0px #E7E7E740 inset;
}

.assignment-item .assignment-name {
  font-size: 20px;
  font-weight: 700;
  color: #0D0D0C;
  display: flex;
  gap: 10px;
  margin: 0;
  align-items: center;
}

.assignment-item .assignment-name .badge {
  border-radius: 24px;
  padding: 4px 10px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-draft {
  color: #FC7A1B !important;
  background-color: #FFE9DA !important;
}

.bg-submitted {
  color: #02A6E7 !important;
  background-color: #DBEAFE !important;
}

.bg-not_started {
  color: #ACACAC !important;
  background-color: #E9E9E9 !important;
}

.bg-over_due {
  color: #A8A8A8 !important;
  background-color: #4A4A4A !important;
}

.bg-completed {
  color: #58CC02 !important;
  background-color: #E9FFD9 !important;
}

.bg-to_do {
  color: #A560EB !important;
  background-color: #EAD4FF !important;
}

.bg-new {
  color: #EF564B !important;
  background-color: #FFBBB6 !important;
}

.assignment-item ul {
  gap: 22px;
  list-style: none;
  padding: 0;
  margin: 0;
}

.assignment-item ul li {
  position: relative;
  color: #ACACAC;
  font-size: 14px;
}

.assignment-item ul li span {
  color: #0D0D0C;
  font-weight: 700;
}

.assignment-item ul li:after {
  position: absolute;
  top: calc(50% - 3px);
  right: -14px;
  content: '';
  display: flex;
  width: 6px;
  height: 6px;
  background: #ACACAC;
  border-radius: 50%;
}

.assignment-item .assignment-point {
  height: 31px;
  background: #F7EFCA;
  border-radius: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1B1B1B;
  font-size: 13px;
  font-weight: 700;
  padding: 8px 16px;
}

.assignment-resubmit-attempts {
  font-size: 12px;
  color: #ACACAC;
  font-weight: 400;
}

.assignment-resubmit-attempts span {
  color: #0D0D0C;
  font-size: 18px;
}

.assignment-item .assignment-point span {
  color: #EF564B;
  font-size: 20px;
  font-weight: 700;
}

.assignment-item ul li:nth-last-child(1):after {
  display: none
}

.border-dashed {
  border: 1px dashed #CCD2E3;
}

.rounded-1rem {
  border-radius: 1rem;
}

.material-name {
  font-size: 10px;
  font-weight: 700;
  color: #0D0D0C;
}

.material-value {
  font-size: 10px;
  font-weight: 400;
  color: #0D0D0C;
}
</style>